import { render, staticRenderFns } from "./CollapsibleAccordion.vue?vue&type=template&id=d7796ebe"
import script from "./CollapsibleAccordion.vue?vue&type=script&lang=js"
export * from "./CollapsibleAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports